import { LoremIpsum } from "utils/storybook";

export const mockBooks = [
  {
    id: 1246,
    title: "13th Street #1: Battle of the Bad-Breath Bats",
    description:
      "A new silly and spooky highly illustrated series that’s perfect for fans of Eerie Elementary and Notebooks of Doom, featuring art on every page and fun activities at the end of each book. It's a Halloween chapter book treat! Cousins Malia, Ivan, and Dante are visiting their aunt Lucy for the summer. But on their way to Gulf City’s water park, they get lost on 13th Street. Only it’s not a street at all. It’s a strange world filled with dangerous beasts! Will the cousins find their way back to Aunt Lucy’s?",
    author: {
      id: 890,
      photo: undefined,
      name: "David Bowles",
      bio: "<p>David Bowles is a Mexican American author from south Texas, where he teaches at the University of Texas Río Grande Valley. He has written several award-winning titles, most notably THE SMOKING MIRROR and THEY CALL ME GÜERO. His work has also been published in multiple anthologies, plus venues such as The New York Times, School Library Journal, Strange Horizons, English Journal, Rattle, Translation Review, and the Journal of Children's Literature. In 2017, David was inducted into the Texas Institute of Letters.</p>",
    },
    contributors: [
      {
        name: "David Bowles",
        bio: "<p>David Bowles is a Mexican American author from south Texas, where he teaches at the University of Texas Río Grande Valley. He has written several award-winning titles, most notably THE SMOKING MIRROR and THEY CALL ME GÜERO. His work has also been published in multiple anthologies, plus venues such as The New York Times, School Library Journal, Strange Horizons, English Journal, Rattle, Translation Review, and the Journal of Children's Literature. In 2017, David was inducted into the Texas Institute of Letters.</p>",
        isAuthor: true,
        isIllustrator: false,
        photo: undefined,
      },
      {
        name: "Shane Clester",
        bio: "<p>Largely self taught, Shane has been a professional illustrator since 2005. Initially working in comics and storyboards, Shane has transitioned to his real passion—children’s books—even self-publishing several of his own. Shane currently lives in Florida with his wonderful wife and their two tots. When not illustrating, he can usually be found by his in-laws' pool.</p>",
        isAuthor: false,
        isIllustrator: true,
        photo: undefined,
      },
    ],
    cover:
      "https://book-assets.literati.dev/covers/6f7ce868-ded6-4c04-9fbb-d930e9ed1d4c.jpg",
    externalCoverUrl:
      "https://book-assets.literati.dev/covers/6f7ce868-ded6-4c04-9fbb-d930e9ed1d4c.jpg",
    summaryTags: ["7 - 9 years"],
    rating: undefined,
    isReviewed: false,
    kept: false,
  },
  {
    id: 1540,
    title:
      "150 Fun Things to Doodle: An interactive adventure in drawing lively animals, quirky robots, and zany doodads",
    description:
      " Anything goes in 150 Fun Things to Doodle! This comprehensive doodling experience for young artists-in-training. Featuring a wide range of popular subjects, from jungle animals, sea life, and pets to robots, tools, and even musical instruments, children will enjoy learning to draw in a new, interactive way thanks to engaging step-by-step lessons and fun creativity prompts. ",
    author: {
      id: 1208,
      photo: undefined,
      name: "Walter Foster Creative",
      bio: "",
    },
    contributors: [
      {
        name: "Walter Foster Creative",
        bio: "",
        isAuthor: true,
        isIllustrator: false,
        photo: undefined,
      },
    ],
    cover:
      "https://book-assets.literati.dev/covers/09cb296c-48c9-4e4c-a4ae-3e456433c090.jpg",
    externalCoverUrl:
      "https://book-assets.literati.dev/covers/09cb296c-48c9-4e4c-a4ae-3e456433c090.jpg",
    summaryTags: ["7 - 9 years"],
    rating: undefined,
    isReviewed: false,
    kept: false,
  },
  {
    id: 1257,
    title: "501 Space Joke-tivities",
    description: "",
    author: {
      id: 891,
      photo: undefined,
      name: "Highlights",
      bio: "",
    },
    contributors: [
      {
        name: "Highlights",
        bio: "",
        isAuthor: true,
        isIllustrator: false,
        photo: undefined,
      },
    ],
    cover:
      "https://book-assets.literati.dev/covers/12f264a8-2d10-4e49-bd65-1c02e4a4c90a.jpg",
    externalCoverUrl:
      "https://book-assets.literati.dev/covers/12f264a8-2d10-4e49-bd65-1c02e4a4c90a.jpg",
    summaryTags: ["7 - 9 years"],
    rating: undefined,
    isReviewed: false,
    kept: false,
  },
  {
    id: 1533,
    title: "50 Maps of the World Activity Book",
    description:
      " In this interactive companion to 50 Maps of the World, you'll find trivia quizzes, search-and-find challenges, spot-the-difference games, and so much more—with over 50 stickers!",
    author: {
      id: 1202,
      photo: undefined,
      name: "Ben Handicott",
      bio: "",
    },
    contributors: [
      {
        name: "Ben Handicott",
        bio: "",
        isAuthor: true,
        isIllustrator: false,
        photo: undefined,
      },
    ],
    cover:
      "https://book-assets.literati.dev/covers/3dbbd938-7a99-49d9-8902-c1559f220f2c.jpg",
    externalCoverUrl:
      "https://book-assets.literati.dev/covers/3dbbd938-7a99-49d9-8902-c1559f220f2c.jpg",
    summaryTags: ["7 - 9 years"],
    rating: undefined,
    isReviewed: false,
    kept: false,
  },
  {
    id: 1157,
    title: "A Boy Called Bat",
    description:
      "Meet Bat, an unforgettable boy on the spectrum who loves animals but hates loud noises. When his veterinarian mom brings home a baby skunk, Bat feels a strong and immediate connection. Your young reader will, too (with Bat, that is—hopefully not with the idea of a pet skunk!)",
    author: {
      id: 872,
      photo: undefined,
      name: "Elana K. Arnold",
      bio: "<p>Elana K Arnold writes books for and about children and teens. Her oeuvre includes DAMSEL, a Printz Honor Winner and a finalist for the California Book Award; What Girls Are Made Of, a finalist for the National Book Award and the California Book Award and the winner of the Golden Kite Award; A Boy Called Bat, a 2018 Global Read Aloud selection; and Infandous, which won the Moonbeam Children's Book Award and the Westchester Fiction Prize. Her books have garnered many starred reviews and have been featured on numerous “Best Books of the Year” lists. She teaches in Hamline University’s low residency MFA program in Writing for Children and Teens and lives in Southern California with her family and a menagerie of animals.<br>\n</p>",
    },
    contributors: [
      {
        name: "Elana K. Arnold",
        bio: "<p>Elana K Arnold writes books for and about children and teens. Her oeuvre includes DAMSEL, a Printz Honor Winner and a finalist for the California Book Award; What Girls Are Made Of, a finalist for the National Book Award and the California Book Award and the winner of the Golden Kite Award; A Boy Called Bat, a 2018 Global Read Aloud selection; and Infandous, which won the Moonbeam Children's Book Award and the Westchester Fiction Prize. Her books have garnered many starred reviews and have been featured on numerous “Best Books of the Year” lists. She teaches in Hamline University’s low residency MFA program in Writing for Children and Teens and lives in Southern California with her family and a menagerie of animals.<br>\n</p>",
        isAuthor: true,
        isIllustrator: false,
        photo: undefined,
      },
      {
        name: "Charles Santoso",
        bio: "<p>Charles Santoso loves drawing little things in his little journal and dreaming about funny, wondrous stories. He gathers inspiration from his childhood memories and curiosities he discovers in his everyday travels.<br>\n</p>\n<p>He has illustrated several picture books, including The Snurtch and I don't Like Koala - both written by Sean Ferrell, Ida, Always - written By Caron Levis, which was mentioned in the New York Times as \"an example of children's books at their best\", Peanut Butter &amp; Brains - written by Joe McGee and Penguin &amp; Tiny Shrimp Don't Do Bedtime - written by Cate Berry. Also a New York Times bestseller Wishtree by Katherine Applegate and A Boy Called Bat by Elana K Arnold.<br>\n</p>\n<p>He worked at Animal Logic as a concept artist/art director and was involved in various animated feature film and tv commercial projects.<br>\n</p>\n<p>Charles Santoso's work has been exhibited in Sydney and also internationally in North America and France.</p>",
        isAuthor: false,
        isIllustrator: true,
        photo: undefined,
      },
    ],
    cover:
      "https://book-assets.literati.dev/covers/d129669e-08d8-4069-a39b-83efc6e95071.jpg",
    externalCoverUrl:
      "https://book-assets.literati.dev/covers/d129669e-08d8-4069-a39b-83efc6e95071.jpg",
    summaryTags: ["7 - 9 years"],
    rating: undefined,
    isReviewed: false,
    kept: false,
  },
  {
    id: 985,
    title: "Ada Lovelace Cracks the Code",
    description:
      "100 years before Silicon Valley, there was Ada Lovelace: female mathematic extraordinaire. From the world of Good Night Stories for Rebel Girls and illustrated by featured artist Marina Munn, this chapter book will help your own young computer whiz (or whizette) gain new respect for the industry.",
    author: {
      id: 1706,
      photo: undefined,
      name: "Rebel Girls",
      bio: "<p>Rebel Girls is the preeminent edutainment company that empowers girls to pursue their dreams without limits. Rebel Girls products inspire children to dream bigger and realize their fullest potential, by introducing them to extraordinary women throughout history. Stories are brought to life through book publishing, podcasts, toys, and digital media. The Rebel Girls community spans over 85 countries, with 5.5M books sold in 49 languages and 6M podcast downloads.</p>",
    },
    contributors: [
      {
        name: "Rebel Girls",
        bio: "<p>Rebel Girls is the preeminent edutainment company that empowers girls to pursue their dreams without limits. Rebel Girls products inspire children to dream bigger and realize their fullest potential, by introducing them to extraordinary women throughout history. Stories are brought to life through book publishing, podcasts, toys, and digital media. The Rebel Girls community spans over 85 countries, with 5.5M books sold in 49 languages and 6M podcast downloads.</p>",
        isAuthor: true,
        isIllustrator: false,
        photo: undefined,
      },
    ],
    cover:
      "https://book-assets.literati.dev/covers/21524293-b840-457a-8552-53b4afd746d2.jpg",
    externalCoverUrl:
      "https://book-assets.literati.dev/covers/21524293-b840-457a-8552-53b4afd746d2.jpg",
    summaryTags: ["7 - 9 years"],
    rating: undefined,
    isReviewed: false,
    kept: false,
  },
  {
    id: 1482,
    title: "A Day in the Life of a Poo, a Gnu, and You",
    description: "",
    author: {
      id: 1143,
      photo: undefined,
      name: "Mike Barfield",
      bio: "<p>Mike Barfield is a writer, poet, performer, songwriter, ukulele player, and cartoonist. He has written extensively for TV and radio - with credits as diverse as Spitting Image, The Dennis the Menace and Gnasher Show and five years on Who Wants To Be A Millionaire. His cartoon feature Apparently has appeared in the pages of Private Eye for over 20 years, and his drawings have been on display in the Cartoon Museum, the V &amp; A, the Museum of London, and Nigella Lawson's downstairs loo.</p>",
    },
    contributors: [
      {
        name: "Mike Barfield",
        bio: "<p>Mike Barfield is a writer, poet, performer, songwriter, ukulele player, and cartoonist. He has written extensively for TV and radio - with credits as diverse as Spitting Image, The Dennis the Menace and Gnasher Show and five years on Who Wants To Be A Millionaire. His cartoon feature Apparently has appeared in the pages of Private Eye for over 20 years, and his drawings have been on display in the Cartoon Museum, the V &amp; A, the Museum of London, and Nigella Lawson's downstairs loo.</p>",
        isAuthor: true,
        isIllustrator: false,
        photo: undefined,
      },
    ],
    cover:
      "https://book-assets.literati.dev/covers/d176f1d9-f539-4356-bcbc-b8fc8b9d22cb.jpg",
    externalCoverUrl:
      "https://book-assets.literati.dev/covers/d176f1d9-f539-4356-bcbc-b8fc8b9d22cb.jpg",
    summaryTags: ["7 - 9 years"],
    rating: undefined,
    isReviewed: false,
    kept: false,
  },
  {
    id: 940,
    title: "Aleca Zamm Is a Wonder",
    description:
      "Meet Aleca, an extraordinarily ordinary ten-year-old who craves something to set her apart. She finds that being special in your own unique way can be a wonderful thing. It’s a lesson we would all do well to remember every now and again, with a cast of lively characters and a touch of magic.\n",
    author: {
      id: 715,
      photo: undefined,
      name: "Ginger Rue",
      bio: "",
    },
    contributors: [
      {
        name: "Ginger Rue",
        bio: "",
        isAuthor: true,
        isIllustrator: false,
        photo: undefined,
      },
    ],
    cover:
      "https://book-assets.literati.dev/covers/271317d2-52d9-46af-958d-74b34cddd3f1.jpg",
    externalCoverUrl:
      "https://book-assets.literati.dev/covers/271317d2-52d9-46af-958d-74b34cddd3f1.jpg",
    summaryTags: ["7 - 9 years"],
    rating: undefined,
    isReviewed: false,
    kept: false,
  },
  {
    id: 439,
    title: "Around the World Mazes",
    description:
      "Can you help rescue stranded researchers in the arctic? How about navigating a tuk tuk through a busy marketplace in southern Asia? (And, by the way, what's a tuk tuk?) Trek across continents, navigate oceans, and explore outer-space on this global map maze quest. With such vivid illustrations, it’s easy to lose yourself in discovering every detail of the page, but don’t look too long- you might get lost!",
    author: {
      id: 324,
      photo: undefined,
      name: "Sam Smith",
      bio: "",
    },
    contributors: [
      {
        name: "Sam Smith",
        bio: "",
        isAuthor: true,
        isIllustrator: false,
        photo: undefined,
      },
    ],
    cover: undefined,
    externalCoverUrl: undefined,
    summaryTags: ["7 - 9 years"],
    rating: undefined,
    isReviewed: false,
    kept: false,
  },
  {
    id: 91,
    title: "Art Detective: Spot the Difference!",
    description:
      "Young Sage, get your magnifying glass ready! It's time to out-sleuth a master forger. Can you uncover the differences between an original painting and its forged copy? A wonderful way to carefully engage 20 iconic works of art that span a wide variety of styles and periods while learning about the history of famous artists. ",
    author: {
      id: 1911,
      photo: undefined,
      name: "Doris Kutschbach",
      bio: "",
    },
    contributors: [
      {
        name: "Doris Kutschbach",
        bio: "",
        isAuthor: true,
        isIllustrator: false,
        photo: undefined,
      },
      {
        name: "Julia Durr",
        bio: "",
        isAuthor: true,
        isIllustrator: false,
        photo: undefined,
      },
    ],
    cover:
      "https://book-assets.literati.dev/covers/d218d898-c6b4-49c4-93c8-e1497a7ed883.jpg",
    externalCoverUrl:
      "https://book-assets.literati.dev/covers/d218d898-c6b4-49c4-93c8-e1497a7ed883.jpg",
    summaryTags: ["7 - 9 years"],
    rating: undefined,
    isReviewed: false,
    kept: false,
  },
];

export const mockBook = {
  id: 678,
  title: "Art Detective: Spot the Difference!",
  description:
    "Young Sage, get your magnifying glass ready! It's time to out-sleuth a master forger. Can you uncover the differences between an original painting and its forged copy? A wonderful way to carefully engage 20 iconic works of art that span a wide variety of styles and periods while learning about the history of famous artists. ",
  author: {
    id: 1911,
    photo: undefined,
    name: "Doris Kutschbach",
    bio: `<p>${LoremIpsum.LONG}${LoremIpsum.LONG}${LoremIpsum.LONG}</p>`,
  },
  contributors: [
    {
      name: "Doris Kutschbach",
      bio: `<p>${LoremIpsum.LONG}${LoremIpsum.LONG}${LoremIpsum.LONG}</p>`,
      isAuthor: true,
      isIllustrator: false,
      photo: undefined,
    },
    {
      name: "Julia Durr",
      bio: `<p>${LoremIpsum.LONG}${LoremIpsum.LONG}${LoremIpsum.LONG}</p>`,
      isAuthor: true,
      isIllustrator: false,
      photo: undefined,
    },
  ],
  cover:
    "https://book-assets.literati.dev/covers/d218d898-c6b4-49c4-93c8-e1497a7ed883.jpg",
  externalCoverUrl:
    "https://book-assets.literati.dev/covers/d218d898-c6b4-49c4-93c8-e1497a7ed883.jpg",
  summaryTags: ["7 - 9 years"],
  rating: undefined,
  isReviewed: false,
  kept: false,
};
